<template>
  <div class="board" >
    <div >
      <Row :gutter="40" justify="center">
        <Col  span="7">
          <div class="cus-data">
            <div class="cus-data-title cus-data-title-bg1" >
              <p class="cus-data-title-p1">客户支出</p>
              <p class="cus-data-title-p2">支出数据</p>
            </div>
            <div class="cus-data-content">
              <div class="cus-data-content-data" v-if="boardData.payoutLastThreeMonthsExpend != '-'">
                <div class="cus-data-content-left" >
                  <span class="data-span">
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>稳定性评级:{{ boardData.payoutStabilityRating }}<br>
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>近3个月均消费:{{ boardData.payoutLastThreeMonths }}元<br>
                     <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>近3个月微信消费:{{ boardData.payoutLastThreeMonthsExpend }}元
                  </span>
                </div>
                <div class="cus-data-content-right" >
                  <span class="data-span">
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>月均支出:{{ homeStat.summary_metrics.payoutMonthAvg }}元<br>
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>近6个月均消费:{{ boardData.payoutLastSixMonths }}元<br>
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>近6个月微信消费:{{ boardData.payoutLastSixMonthsExpend }}元
                  </span>
                </div>
              </div>
              <div class="cus-data-content-data" v-else>
                <div class="cus-data-content-left" >
                  <span class="data-span">
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>稳定性评级:{{ boardData.payoutStabilityRating }}<br>
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>近3个月均消费:{{ boardData.payoutLastThreeMonths }}元
                   <br><br>
                  </span>
                </div>
                <div class="cus-data-content-right" >
                  <span class="data-span">
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>月均支出:{{ homeStat.summary_metrics.payoutMonthAvg }}元<br>
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>近6个月均消费:{{ boardData.payoutLastSixMonths }}元<br><br>
                  </span>
                </div>
              </div>
              <div class="cus-data-content-foot" >
                <div class="cus-data-content-describe">
                  <span class="clms-font">策略描述</span><br>
                  提供客户消费能力与消费数据，依据客户日常支出数据，预计客户收入能力，稳定性分为高中/低依次变差，近3个月按照近90天，近6个月按照近180天取数，下同
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col  span="7">
          <div class="cus-data">
            <div class="cus-data-title cus-data-title-bg2" >
              <p class="cus-data-title-p1">客户收入</p>
              <p class="cus-data-title-p2">收入数据</p>
            </div>
            <div class="cus-data-content">
              <div class="cus-data-content-data">
                  <div class="cus-data-content-left" >
                    <span class="data-span">
                      <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>稳定性评级：{{ boardData.incomeStabilityRating }}<br>
                      <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>近3个月均收入：{{ boardData.incomeLastThreeMonths }}元
                         <br><br>
                    </span>
                  </div>
                  <div class="cus-data-content-right" >
                    <span class="data-span">
                      <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>月均收入：{{ homeStat.summary_metrics.incomingMonthAvg}}元<br>
                      <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>近6个月均收入：{{ boardData.incomeLastSixMonths }}元
                    </span>
                  </div>

              </div>
              <div class="cus-data-content-foot" >
                <div >
                </div>
                <div class="cus-data-content-describe">
                  <span class="clms-font">策略描述</span><br>
                  提供客户收入能力与收入数据，依据客户收入数据，预计客户消费能力，稳定性分为高中/低依次变差，近3个月按照近90天，近6个月按照近180天取数，下同
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col  span="7">
          <div class="cus-data">
            <div class="cus-data-title cus-data-title-bg3" >
              <p class="cus-data-title-p1">客户资产</p>
              <p class="cus-data-title-p2">日均资产</p>
            </div>
            <div class="cus-data-content">
              <div class="cus-data-content-data">
                <div class="cus-data-content-left">
                  <span class="data-span">
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>稳定性评级:{{ boardData.assetDataStabilityRating }}<br>
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>近3个月日均:{{ boardData.assetDataThreeMonthDayAvg }}元
                    <br><br>
                  </span>
                </div>
                <div class="cus-data-content-right">
                  <span class="data-span">
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>日均资产:{{ homeStat.summary_metrics.assetDayAvg }}元<br>
                    <Icon type="md-checkmark-circle" class="md-checkmark-circle"/>近6个月日均:{{ boardData.assetDataSixMonthDayAvg }}元<br><br>
                  </span>
                </div>
              </div>
              <div class="cus-data-content-foot" >
                <div >
                </div>
                <div class="cus-data-content-describe">
                  <span class="clms-font">策略描述</span><br>
                  提供客户的银行卡余额日均情况，辅助证明客户的日常资产是否能否覆盖贷款额
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
    <div class="content-bv" >
      <div class="bv-title">
        <span class="bv-title-cn">账单校验</span>
        <br>
        <span class="bv-title-en">BILL VERIFICATION</span>
      </div>
      <div class="bv-table">
        <Table border disabled-hover :columns="uploadColumns" :data="dataMap.uploadLog"></Table>
      </div>
      <div class="bv-foot bv-foot-font" >
        <span style="font-weight: bold;">策略描述</span><br>
        <span class="">微信和支付宝以及部分银行卡支持电子签名校验，如果电子签名校验失败则文件被改动过，<br>银行卡会进行余额连续性校验，即每笔交易金额是不是等于下一笔余额，极少银行交易排序不准确可能存在异常校验 ，详情有具体异常交易流水可以进行核验。</span>
      </div>
    </div>
    <div class="content-settlement" v-if="dataMap.bank_view_data && dataMap.bank_view_data.length>0">
      <div class="bv-title">
        <span class="bv-title-cn">常用银行卡</span>
        <br>
        <span class="bv-title-en">COMMON BANK CARDS</span>
      </div>
      <div class="settlement-pic-table">
        <div class="bv-table">
          <Table border disabled-hover :columns="transferSummary" :data="dataMap.bank_view_data"></Table>
        </div>
      </div>
    </div>
    <div class="content-settlement" v-if="boardData && boardData.settlementMapList && boardData.settlementMapList.length>0">
      <div class="bv-title">
        <span class="bv-title-cn">结息校验</span>
        <br>
        <span class="bv-title-en">INTEREST SETTLEMENT</span>
      </div>
      <div class="settlement-pic-table">
        <div class="bv-table">
          <Table border disabled-hover :columns="settlement" :data="boardData.settlementMapList"></Table>
        </div>
      </div>
      <div class="bv-foot bv-foot-font" >
        <span style="font-weight: bold;">策略描述</span><br>
        <span class="">根据客户的日均余额与活期利率计算与客户账单结息进行比对，判断客户是否存在造假行为。</span>
      </div>
    </div>
<!--    <div class="content-bh">
      <div class="bv-title">
        <span class="bv-title-cn">司法与不良嗜好校验</span>
        <br>
        <span class="bv-title-en">JUDICIAL AND BAD HOBBY VERIFICATION</span>
      </div>
      <div class="bv-table">
        <Table border disabled-hover :columns="badHabit" :data="badHabitData"></Table>
      </div>
    </div>
    <div class="bv-foot bv-foot-font" >
        <span style="font-weight: bold;">策略描述</span><br>
        <span class="">不良嗜好识别数据，展示客户行为情况。</span><br>
        <span style="font-weight: bold;">娱乐校验：</span><span>消费中KTV会所等相关信息的所有支出且金额大于500,辅助判断客户是否存在黄赌情况。</span><br>
        <span style="font-weight: bold;">高频转账：</span><span>一天内向同一对象转账超过五次，辅助判断客户是否存在关联交易和赌博情况。</span><br>
        <span style="font-weight: bold;">夜间交易：</span><span>晚上24点到早上5点之间交易，少量可以忽略大量查看是否匹配行业，辅助判断客户是否存在赌博情况。</span><br>
        <span style="font-weight: bold;">典当交易：</span><span>客户典当交易情况，辅助判断客户是否存在赌博情况。</span><br>
        <span style="font-weight: bold;">司法校验：</span><span>判断微信或者支付宝以及银行账单中是否存在司法冻结或者司法解冻的情况，如果存在表明已经存在严重逾期。</span>
    </div>-->
    <div class="content-bh" v-if="comInfo">
      <div class="bv-title">
        <span class="bv-title-cn">公司基本信息</span>
        <br>
        <span class="bv-title-en">BASIC COMPANY INFORMATION</span>
      </div>
      <div class="bv-table">
        <table class="com-table com-table-cls">
          <tr>
            <td class="title-bg-color" style="width: 10%">企业名称</td>
            <td style="width: 20%">{{comInfo.name}}</td>
            <td class="title-bg-color" style="width: 10%">法定代表人</td>
            <td style="width: 20%">{{comInfo.legalPersonName}}</td>
            <td class="title-bg-color" style="width: 10%">登记状态</td>
            <td style="width: 20%">{{comInfo.regStatus}}</td>
          </tr>
          <tr>
            <td class="title-bg-color">成立日期</td>
            <td>{{comInfo.estiblishTime}}</td>
            <td class="title-bg-color" >统一社会信用代码</td>
            <td>{{comInfo.creditCode}}</td>
            <td class="title-bg-color">注册资本</td>
            <td>{{comInfo.regCapital}}</td>
          </tr>
          <tr>
            <td class="title-bg-color">实收注册资金</td>
            <td>{{comInfo.actualCapital}}</td>
            <td class="title-bg-color">工商注册号</td>
            <td>{{comInfo.regNumber}}</td>
            <td class="title-bg-color">纳税人识别号</td>
            <td>{{comInfo.taxNumber}}</td>
          </tr>
          <tr>
            <td class="title-bg-color">组织机构代码</td>
            <td>{{comInfo.orgNumber}}</td>
            <td class="title-bg-color">营业期限</td>
            <td>{{ parseTime(comInfo.fromTime) }} 至 {{comInfo.toTime?comInfo.toTime:'无固定期限'}}</td>
            <td class="title-bg-color">核准日期</td>
            <td>{{ parseTime(comInfo.approvedTime)}}</td>
          </tr>
          <tr>
            <td class="title-bg-color">企业类型</td>
            <td>{{comInfo.companyOrgType}}</td>
            <td class="title-bg-color">行业</td>
            <td>{{comInfo.industry}}</td>
            <td class="title-bg-color">人员规模</td>
            <td>{{comInfo.staffNumRange}}</td>
          </tr>
          <tr>
            <td class="title-bg-color">参保人数</td>
            <td>{{comInfo.socialStaffNum}}</td>
            <td class="title-bg-color">英文名</td>
            <td>{{comInfo.property3}}</td>
            <td class="title-bg-color">登记机关</td>
            <td>{{comInfo.regInstitute}}</td>
          </tr>
          <tr>
            <td class="title-bg-color">注册地址</td>
            <td>{{comInfo.regLocation}}</td>
            <td class="title-bg-color">邮箱</td>
            <td>{{comInfo.email}}</td>
            <td class="title-bg-color">网址</td>
            <td>{{comInfo.websiteList}}</td>
          </tr>
          <tr>
            <td class="title-bg-color">企业联系方式</td>
            <td>{{comInfo.phoneNumber}}</td>
            <td class="title-bg-color">股票名</td>
            <td>{{comInfo.bondName}}</td>
            <td class="title-bg-color">股票号</td>
            <td>{{comInfo.bondNum}}</td>
          </tr>
          <tr>
            <td class="title-bg-color">经营范围</td>
            <td colspan="5">{{comInfo.businessScope}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="content-bh" v-if="comInfo && staffList">
      <div class="bv-title">
        <span class="bv-title-cn">公司主要人员</span>
        <br>
        <span class="bv-title-en">MAIN PERSONNEL OF THE COMPANY</span>
      </div>
      <div class="bv-table">
        <Table border disabled-hover :columns="mainPersonnel" :data="staffList"></Table>
      </div>
  </div>
    <div class="content-bh" >
      <div class="bv-title">
        <span class="bv-title-cn">司法解析</span>
        <br>
        <span class="bv-title-en">JUDICIAL ANALYSIS</span>
      </div>
      <div class="bv-table">
        <Table border disabled-hover :columns="judicialList" :data="items"></Table>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    dataMap: Object,
    homeStat: Object,
    score: Object,
    boardData: Object,
    comInfo: Object,
    judicial: Object
  },
  data () {
    return {
      gutter: 52,
      staffList: [],
      items: [],
      judicialList:
      [{
        key: 'caseTitle',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'md-albums'
              },
              style: {
                marginRight: '5pt'
              }
            }),
            h('strong', '案件名称')
          ])
        }
      }, {
        key: 'caseCode',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-albums'
              },
              style: {
                marginRight: '5pt'
              }
            }),
            h('strong', '案号')
          ])
        }
      }, {
        key: 'trialTime',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-calendar'
              },
              style: {
                marginRight: '5pt'
              }
            }),
            h('strong', '当前审理程序日期')
          ])
        }
      }, {
        key: 'caseIdentitys',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-person'
              },
              style: {
                marginRight: '5pt'
              }
            }),
            h('strong', '案件身份')
          ])
        }
      }, {
        key: 'trialProcedure',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-bookmarks'
              },
              style: {
                marginRight: '5pt'
              }
            }),
            h('strong', '当前审理程序')
          ])
        }
      }, {
        key: 'caseReason',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-book'
              },
              style: {
                marginRight: '5pt'
              }
            }),
            h('strong', '案由')
          ])
        }
      }, {
        key: 'caseType',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'md-barcode'
              },
              style: {
                marginRight: '5pt'
              }
            }),
            h('strong', '案件类型')
          ])
        }
      }],
      mainPersonnel:
        [{
          key: 'name',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-person'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '姓名')
            ])
          }
        }, {
          key: 'typeJoins',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-briefcase'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '职位')
            ])
          }
        }, {
          key: 'type',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-barcode'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '类型')
            ])
          },
          render: (h, params) => {
            return h('div', [
              h('div', params.row.type === 1 ? '公司' : '自然人')
            ])
          }
        }],
      uploadColumns:
        [{
          key: 'billType',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-paper'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '账单类型')
            ])
          }
        }, {
          key: 'name',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-person'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '姓名')
            ])
          }
        }, {
          key: 'bankCardNo',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-card'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '账户')
            ])
          }
        }, {
          key: 'fileName',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-folder'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '文件')
            ])
          }
        }, {
          key: 'uploadTime',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-clock'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '上传时间')
            ])
          }
        }, {
          key: 'signNums',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-pricetag'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '电子签校验')
            ])
          }
        }, {
          key: 'continuity',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-checkmark-circle'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '余额连续性校验')
            ])
          }
        }],
      transferSummary:
        [
          {
            key: 'cardNo',
            className: 'table-header-cell',
            renderHeader: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'md-shuffle'
                  },
                  style: {
                    marginRight: '5pt'
                  }
                }),
                h('strong', '渠道名称')
              ])
            }
          }, {
            key: 'businessType',
            className: 'table-header-cell',
            renderHeader: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'ios-card'
                  },
                  style: {
                    marginRight: '5pt'
                  }
                }),
                h('strong', '银行/卡号')
              ])
            }
          }, {
            key: 'yearAvg',
            className: 'table-header-cell',
            renderHeader: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'logo-yen'
                  },
                  style: {
                    marginRight: '5pt'
                  }
                }),
                h('strong', '收入')
              ])
            }
          },
          {
            key: 'monthAvg',
            className: 'table-header-cell',
            renderHeader: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'logo-yen'
                  },
                  style: {
                    marginRight: '5pt'
                  }
                }),
                h('strong', '支出')
              ])
            }
          },
          {
            key: 'countData',
            className: 'table-header-cell',
            renderHeader: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'ios-podium'
                  },
                  style: {
                    marginRight: '5pt'
                  }
                }),
                h('strong', '交易笔数')
              ])
            }
          }, {
            key: 'money',
            className: 'table-header-cell',
            renderHeader: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'md-basket'
                  },
                  style: {
                    marginRight: '5pt'
                  }
                }),
                h('strong', '交易金额')
              ])
            }
          }, {
            key: 'dayAvg',
            className: 'table-header-cell',
            renderHeader: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'md-cloud-upload'
                  },
                  style: {
                    marginRight: '5pt'
                  }
                }),
                h('strong', '是否已上传')
              ])
            },
            render: (h, params) => {
              return h('div', [
                h('div', params.row.dayAvg === 'Y' ? '是' : '否')
              ])
            }
          },
          {
            key: 'billAvg',
            className: 'table-header-cell',
            renderHeader: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'ios-checkmark-circle'
                  },
                  style: {
                    marginRight: '5pt'
                  }
                }),
                h('strong', '交叉检验')
              ])
            },
            render: (h, params) => {
              return h('div', [
                h('div', params.row.billAvg === 'Y' ? '通过' : (params.row.billAvg === 'N' ? '未通过' : ''))
              ])
            }
          }],
      settlement:
        [{
          key: 'billAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-card'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '银行')
            ])
          }
        }, {
          key: 'statTime',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-clock'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '结息日期')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'logo-yen'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '结息金额')
            ])
          }
        }, {
          key: 'yearAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-pulse'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '利率')
            ])
          }
        }, {
          key: 'billType',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-bookmark'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '是否有效结息')
            ])
          }
        }, {
          key: 'monthAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-analytics'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '计算结息')
            ])
          }
        }, {
          key: 'dayAvg',
          className: 'table-header-cell',
          render: (h, params) => {
            return h('div', [
              h('suibianxie', params.row.dayAvg ? params.row.dayAvg + '%' : '')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-sad'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '偏差率')
            ])
          }
        }],
      badHabit:
        [{
          key: 'billType',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'logo-playstation'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '娱乐校验')
            ])
          }
        }, {
          key: 'name',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'logo-buffer'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '高频转账')
            ])
          }
        }, {
          key: 'bankCardNo',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-moon'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '夜间交易')
            ])
          }
        }, {
          key: 'pwan',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-cash'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '典当交易')
            ])
          }
        }, {
          key: 'judicial',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-cash'
                },
                style: {
                  marginRight: '5pt'
                }
              }),
              h('strong', '司法校验')
            ])
          }
        }
        ],
      badHabitData: [ {
        billType: '涉及金额:￥' + this.homeStat.blackTrade.leisureEntertainment.money + '元',
        name: '涉及金额:￥' + this.homeStat.blackTrade.highFrequencyTransfer.money + '元',
        bankCardNo: '涉及金额:￥' + this.homeStat.blackTrade.nightTradeList.money + '元',
        pwan: '涉及金额:￥' + this.homeStat.blackTrade.pawnTradingList.money + ' 元',
        judicial: '涉及金额:￥' + this.homeStat.blackTrade.judicialFreeze.money + ' 元'
      }, {
        billType: this.getBlackTradeResult(this.homeStat.blackTrade.leisureEntertainment.money),
        name: this.getBlackTradeResult(this.homeStat.blackTrade.highFrequencyTransfer.money),
        bankCardNo: this.getBlackTradeResult(this.homeStat.blackTrade.nightTradeList.money),
        pwan: this.getBlackTradeResult(this.homeStat.blackTrade.pawnTradingList.money),
        judicial: this.getBlackTradeResult(this.homeStat.blackTrade.judicialFreeze.money)
      }
      ]
    }
  },
  mounted: function () {
    this.typeJoin(this.$parent.comInfo)
    this.caseIdentity(this.$parent.judicial)
  },
  methods: {
    caseIdentity (judicial) {
      this.items = judicial.items
      for (let i = 0; i < this.items.length; i++) {
        let caseIdentitys = ''
        for (let j = 0; j < this.items[i].caseIdentity.length; j++) {
          caseIdentitys = caseIdentitys + this.items[i].caseIdentity[j] + ','
        }
        caseIdentitys = caseIdentitys.substring(0, caseIdentitys.length - 1)
        this.items[i].caseIdentitys = caseIdentitys
      }
    },
    typeJoin (comInfo) {
      this.staffList = comInfo.staffList.result
      for (let i = 0; i < comInfo.staffList.result.length; i++) {
        let typeJoins = ''
        for (let j = 0; j < comInfo.staffList.result[i].typeJoin.length; j++) {
          typeJoins = typeJoins + comInfo.staffList.result[i].typeJoin[j] + ','
        }
        typeJoins = typeJoins.substring(0, typeJoins.length - 1)
        this.staffList[i].typeJoins = typeJoins
      }
    },
    getBlackTradeResult (money) {
      if (money === '0') {
        return '通过'
      } else {
        return '存在,请重点关注'
      }
    },
    parseTime (timestamp) {
      var time = new Date(timestamp)
      var y = time.getFullYear()
      var m = time.getMonth() + 1
      var d = time.getDate()
      return y + '-' + this.add0(m) + '-' + this.add0(d)
    },
    add0 (m) {
      return m < 10 ? '0' + m : m
    }
  }
}
</script>
<style>

.ivu-table td {
  background-color: #F5F5F5;
}
.ivu-table th.table-header-cell {
  background: #1242CD;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 12pt;
  color: #FFFFFF;
  text-align: center;
  border: #1242CD;
}
.board {
  width: 100%;
}
.cus-data {
  width: 90%;
  height: 100%;
  background: #FFFFFF;
  box-shadow: 0 0 30pt 0 rgba(0,0,0,0.06);
  padding-top: 5%;
  border-radius: 30px;
}
.cus-data-title {
  width: 90%;
  margin-left: 5%;
  aspect-ratio: 800 / 278;
  font-family: Microsoft YaHei;
  color: #FFFFFF;
  font-size: 20pt;
  padding-top: 5%;
}
.cus-data-title-p1 {
  margin-left: 5%;
  font-size: 20pt;
  font-weight: bold;
}
.cus-data-title-p2 {
  font-size: 14pt;
  margin-left: 5%;
  margin-top: 4%;
}
.cus-data-title-bg1 {
  background-image: url(../../../../assets/images/content-v4/board/cust-data-title1.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.cus-data-title-bg2 {
  background-image: url(../../../../assets/images/content-v4/board/cust-data-title2.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.cus-data-title-bg3 {
  background-image: url(../../../../assets/images/content-v4/board/cust-data-title3.png);
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.cus-data-content {
  //height: 400pt;
  width: 100%;
}
.cus-data-content-data {
  margin-top: 10pt;
}
.data-span {
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 10pt;
  color: #333333;
  line-height: 30pt;
}
.clms-font {
  font-family: Microsoft YaHei;
  font-size: 10pt;
  color: #666666;
}
.cus-data-content-describe {
  //height: 96pt;
  //height: 100%;
  margin: 0 20pt 20pt 20pt;
  font-family: Microsoft YaHei;
  font-size: 8pt;
  color: #999999;
  line-height: 17pt;
}
.cus-data-content-foot {
  margin-top: 5%;
}
.content-bv {
  margin-top: 20pt;
}
.bv-title-cn {
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 14pt;
  color: #333333;
}
.bv-title-en {
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 8pt;
  color: #999999;
}
.bv-table {
  margin-top: 10pt;
}
.bv-foot {
  margin-top: 10pt;
}
.bv-foot-font {
  font-family: Microsoft YaHei;
  font-size: 8pt;
  color: #333333;
}
.content-settlement {
  margin-top: 20pt;
}
.settlement-pic-table {
  //margin-top: 35pt;
}

.content-bh {
  margin-top: 20pt;
}
.md-checkmark-circle {
  color: #1342CE;
}
.cus-data-content-left {
  display: inline-block;
  vertical-align: top;
  width: 45%;
  margin-left: 5%;
  border-right:1px dashed #d3caca;
}
.cus-data-content-right {
  display: inline-block;
  vertical-align: top;
  width: 45%;
  margin-right: 5%;
}
.com-table {
  margin-bottom: 10pt;
  width: 100%;
  border: 1px solid #85c3f4; /* 设置单线边框 */
  border-collapse: collapse; /* 使边框合并为单一边框 */
}
.com-table td{
  border: 1px solid #85c3f4; /* 设置单线边框 */
  border-collapse: collapse; /* 使边框合并为单一边框 */
}
.title-bg-color {
  background-color:#f0f7fc
}
.com-table td {
  padding:4pt
}
</style>
